module.exports = __webpack_public_path__ + "static/media/davlenie.06fc9925.pdf";